import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { PropertySimilar } from '@shared-ui/lodging-property-details';
import { SimpleLazyLoadWrapper } from 'src/common/components/common/lazy/simple-lazy-load-wrapper';
const SimilarPropertiesWrapper = ({
  inputs
}) => {
  var _a;
  if (inputs && !((_a = inputs.shoppingContext) === null || _a === void 0 ? void 0 : _a.multiItem)) {
    return React.createElement(EGDSSpacing, {
      margin: {
        block: 'three'
      },
      padding: {
        blockstart: 'two'
      }
    }, React.createElement("div", {
      "data-stid": "SimilarProperties"
    }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(PropertySimilar, {
      inputs: inputs,
      skipSsr: true,
      scrollTo: "Offers"
    }))));
  }
  return null;
};
export const SharedUiSimilarPropertiesWrapper = SimilarPropertiesWrapper;
SharedUiSimilarPropertiesWrapper.displayName = 'SharedUiSimilarPropertiesWrapper';